import {
  Control,
  Controller,
  FormState,
  UseFormHandleSubmit,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Form, ModalContent } from 'semantic-ui-react';

import { SelectAutocomplete } from '../../../../components/Inputs/SelectAutocomplete';
import sbu from '../../../../mocks/sbu.json';
import { StructureDataForm } from '../../../../types/structure';

interface IProps {
  control?: Control<StructureDataForm, object>;
  formRef?: React.RefObject<HTMLFormElement>;
  onSubmit: (data: StructureDataForm) => Promise<void>;
  handleSubmit: UseFormHandleSubmit<StructureDataForm>;
  setValue?: UseFormSetValue<StructureDataForm>;
  watch: UseFormWatch<StructureDataForm>;
  formState: FormState<StructureDataForm>;
}

function FormContent({
  control,
  formRef,
  onSubmit,
  handleSubmit,
  formState,
}: IProps) {
  const { t } = useTranslation();
  return (
    <ModalContent>
      <Form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
        <Form.Group grouped>
          <Form.Field label={t('pages.structure.sbu')} required />
          <SelectAutocomplete
            controllerControl={control}
            controllerName="region"
            options={sbu ?? []}
            fluid
            required
            error={
              formState.errors.region?.type === 'required' &&
              t('pages.structure.form.required.region')
            }
          />
        </Form.Group>
        <Controller
          control={control}
          name="country"
          rules={{
            required: true,
          }}
          render={({ field: { onChange, value } }) => (
            <>
              <Form.Field label={t('pages.structure.country')} required />
              <Form.Input
                type="text"
                onChange={onChange}
                value={value}
                error={
                  formState.errors.country?.type === 'required' &&
                  t('pages.structure.form.required.country')
                }
              />
            </>
          )}
        />
        <Controller
          control={control}
          name="language"
          rules={{
            required: true,
          }}
          render={({ field: { onChange, value } }) => (
            <>
              <Form.Field label={t('pages.structure.language')} required />
              <Form.Input
                type="text"
                placeholder="XX-XX"
                onChange={onChange}
                value={value}
                error={
                  formState.errors.language?.type === 'required' &&
                  t('pages.structure.form.required.language')
                }
              />
            </>
          )}
        />
      </Form>
    </ModalContent>
  );
}

export { FormContent };
